import React from 'react'
import { BsArrowRight } from 'react-icons/bs'
import ecommerce from '../../../assets/ecommerce.svg'
import dotted from '../../../assets/dotted2.svg'
import { Button } from '../../../UI'
import Container from './styles'
import { useNavigate } from 'react-router-dom'

const SectionThree = () => {

   const navigate = useNavigate()

  return (
    <Container>
      <img src={dotted} className="dotted--float" alt={'dotted'} />
      <div className="col--1">
        <h2>
          Check out our leading <br />
          E-commerce Website
        </h2>
        <p>
        We are currently building an online marketplace that connects buyers and sellers and provide the
tooling to exchange goods and services. This platform leverages on our logistic platform to power its
delivery. Click on the See More button to have a quick peek.
        </p>
        <Button onClick={()=>navigate("/track-order") }>
          See More <BsArrowRight />
        </Button>
      </div>
      <div className="col--2">
        <img src={ecommerce} alt={'ecommerce'} />
      </div>
    </Container>
  )
}

export default SectionThree
